export const colors = {
  disabled: '#b5b5b5',
  green: '#00d47f',
  red: {
    warning: '#FF6363',
    i500: '#963753',
    i600: `#ED856A`,
    i800: `#541829`,
  },
  primary: {
    text: `#525f7f`,
    pink: `#F95A86`,
  },
  secondary: {
    text: `#525f7f`,
  },
  text: '#525f7f',
  grey: {
    i800: `#3F4B5B`,
    i600: `#A3B2C2`,
    i400: `#E2EAF2`,
    i200: `#F7F8FC`,
  },
  purple: {
    i400: `#B09AE3`,
    i500: `#A182E9`,
    i600: `#755FA7`,
    i700: `#6A539F`,
  },
  blue: {
    i600: `#525f7f`,
  },
  orange: {
    i500: `#ED856A`,
  },
  teal: {
    i300: `#98E8F1`,
    i500: `#18C3C3`,
    i800: `#147590`,
  },
  black: {
    i800: `#3E3A37`,
  },
}
